<rx-modal-content (closeModal)="activeModal.dismiss()">
  <h3 class="modal-title">{{ title }}</h3>
  <div class="modal-body">
    <div [innerHTML]="reservationTermsFormatted | cleanupHtml | safeHtml"></div>
    <div #nosanitize></div>
  </div>
</rx-modal-content>